// modules
import * as R from 'ramda'
import { combineEpics } from 'redux-observable'
import { debounceTime, filter, pluck, tap } from 'rxjs/operators'
// action
import {
  dispatchSetWindowDimension,
  SET_LOADED,
  SET_WINDOW_FOCUS,
} from './root.action'
// helper
import subscribe from '../../helper/functions/subscribe'
import { useObservable } from '$func/effectUtils'
import { getOpenedRoomId } from '$logic/opened-room'

const setWindowFocusEpic = subscribe(SET_WINDOW_FOCUS, action$ =>
  action$.pipe(
    filter(({ payload: { value } }) => value && getOpenedRoomId()),
    tap(() => {
      //  TODO: Set seen messages
    }),
  ),
)

const setLoadedEpic = subscribe(SET_LOADED, action$ =>
  action$.pipe(
    pluck('payload', 'loaded'),
    filter(R.identity),
    tap(() => {
      const preloader = document.getElementById('preloader')
      if (preloader) preloader.parentNode.removeChild(preloader)
    }),
  ),
)

export const effectOnWindowResize = useObservable(size$ =>
  size$.pipe(
    debounceTime(100),
    // tap(({ width, height }) => analite('SIZE', { w: width, h: height })),
    tap(({ width, height }) => dispatchSetWindowDimension(width, height)),
  ),
)

export default combineEpics(setWindowFocusEpic, setLoadedEpic)
